import { TournamentInvitation } from '../models';
import { TournamentInvitationRepository } from '../repositories/TournamentInvitationRepository';
import { logger } from '@/src/core/utils';

export class CancelTournamentInvitationUseCase {
  constructor(private invitationRepository: TournamentInvitationRepository) {}

  async execute(invitationId: string): Promise<TournamentInvitation> {
    logger.debug('CancelInvitation', 'Cancelling invitation', { invitationId });
    return this.invitationRepository.cancel(invitationId);
  }
}
